export default __webpack_public_path__ + "static/media/3a9fa8dd00a6fdc22f21a578715fbdd.cf330830.jpeg";